// Author YuJiaBei
// Date 2020-10-10 14:00:25

class SithMesMstLocationShiftRule {
constructor({
        id = null,
        mstLocationId = '',
        mstShiftRuleId = '',
        beginDate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mstLocationId = mstLocationId;
    this.mstShiftRuleId = mstShiftRuleId;
    this.beginDate = beginDate;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstLocationShiftRule();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleName',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.mstShiftRuleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleType',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.mstShiftRuleType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '节假日休息' },
                            { value: '2', text: '节假日不休息' }
            ]
        }
        },
        {
        key: 'mstShiftRuleLoopRule',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.mstShiftRuleLoopRule',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleSwitchingCycle',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.mstShiftRuleSwitchingCycle',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleEachShiftDuration',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.mstShiftRuleEachShiftDuration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleBeginTime',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.mstShiftRuleBeginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'beginDate',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.beginDate',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    mstLocationIdFilter : "",
    mstLocationNodeCodeStartsWithFilter : "",
    mstShiftRuleIdFilter : "",
    beginDateRteFilter : "",
    beginDateLteFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'mstLocationIdFilter',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.filter.mstLocationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstShiftRuleIdFilter',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.filter.mstShiftRuleId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstShiftRule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'beginDateRteFilter',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.filter.beginDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'beginDateLteFilter',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.filter.beginDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mstLocationId',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.entity.mstLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstShiftRuleId',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.entity.mstShiftRuleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'sithMesMstShiftRule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'beginDate',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.entity.beginDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstLocationShiftRule.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstLocationShiftRule, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
